enum ButtonSizes {
    Small = 'btn-sm',
    XLarge = 'btn-xl'
}

export default ButtonSizes;